export const getUrlQueryEncode = (query = {}) => {
  const result = {};
  for (const key in query) {
    const item = query[key];

    if (Array.isArray(item)) {
      result[key] = item.toString();
    } else if (typeof item === 'boolean') {
      result[key] = item;
    } else if (typeof item === 'number') {
      result[key] = item;
    } else if (item === null || item) {
      result[key] = item;
    }
  }
  return result;
};

export const getUrlQueryDecode = (query = {}) => {
  const result = {};

  for (const key in query) {
    const item = query[key];

    if (typeof item === 'string') {
      if (item.length && item.match(/,/gi)) {
        const array = item.split(',');
        result[key] = array;
      } else {
        result[key] = item;
      }
    } else if (item) {
      result[key] = item;
    }
  }

  return result;
};

export const getUrlCurrentQuery = (filters = {}) => {
  const result = {};
  for (const key in filters) {
    const item = filters[key];

    if (item) {
      result[key] = item;
    }
  }

  return result;
};

export const getUrlParams = (params = '') => new URLSearchParams(params);
